import { Box, Typography } from '@mui/material';
import BackgroundImage from '../../assets/motorcade/Motorcade_Lander_Banner_background.png';
import { FC } from 'react';
interface IProps {
	text?: string | React.ReactNode;
}
const MotorcadeLanderBanner: FC<IProps> = ({ text = 'Welcome to Motorcade' }) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				backgroundColor: theme.palette.primary.dark,
				backgroundImage: `url(${BackgroundImage})`,
				padding: 2,
				overflow: 'hidden',
				paddingBottom: '30%',
				[theme.breakpoints.down('md')]: {
					height: '250px',
				},
			})}
		>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					zIndex: 200,
					top: {
						xs: '52%',
						sm: '62%',
						md: '50%',
					},
					left: {
						xs: '57%',
						sm: '57%',
						md: '50%',
					},
					bottom: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					transform: 'translate(-80%, -65%)',
					overflow: 'hidden',
					width: '50%',
					[theme.breakpoints.down('md')]: {
						width: '70%',
						transform: 'translate(-70%, -65%)',
					},
				})}
			>
				<Typography
					variant='h4'
					sx={(theme) => ({
						color: 'primary.light',
						fontSize: '2.5rem',
						textTransform: 'capitalize',
						[theme.breakpoints.down('md')]: {
							fontSize: '6vw',
						},
					})}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default MotorcadeLanderBanner;
